import { AccessLevel } from "@/api/williams/users";
import { areAnyTestsCompleted, doesWelderHaveTest, isTestCompleted } from "../lookup/utils";
import { downloadCertificate } from "@/api/williams/certificates";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StandardTest } from "@/api/williams/tests";
import { TestEvent } from "@/api/williams/testEvents";
import { usePermissions } from "../../users/hooks";
import { Welder } from "@/api/williams/welders";

export type TEFormWeldersMobileProps = {
  data: TestEvent;
  handleRemoveWelder: (welder: Welder) => void;
  handleTestSelectionChanged: (test: StandardTest, welder: Welder, selected: boolean) => void;
};

export function TEFormWeldersMobile({ data, ...props }: Readonly<TEFormWeldersMobileProps>) {
  const permissions = usePermissions();

  return (
    <>
      {data.welders.map((welder) => (
        <table key={welder.welderId} className="table table-sm">
          <thead className="table-light">
            <tr>
              <th colSpan={2}>
                <div className="d-flex justify-content-between">
                  <span>
                    {welder.badgeNumber} {welder.name && <>({welder.name})</>}
                  </span>
                  <button
                    type="button"
                    className="btn btn-link text-black p-0 lh-sm mt-auto"
                    title="Remove Welder"
                    onClick={() => props.handleRemoveWelder(welder)}
                    disabled={data.locked || areAnyTestsCompleted(data, welder)}
                    hidden={permissions.data?.accessLevel === AccessLevel.GeneralUser}
                  >
                    <FontAwesomeIcon role="button" icon={faXmark} border={true} />
                  </button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.tests.map((test) => (
              <tr key={test.recordId}>
                <td>
                  <a onClick={() => downloadCertificate(test.recordId)}>{test.templateNumber}</a>
                </td>
                <td className="text-end">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={doesWelderHaveTest(data, welder, test)}
                    onChange={(e) => props.handleTestSelectionChanged(test, welder, e.currentTarget.checked)}
                    disabled={
                      data.locked ||
                      permissions.data?.accessLevel === AccessLevel.GeneralUser ||
                      isTestCompleted(data, welder, test)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </>
  );
}
